// extracted by mini-css-extract-plugin
module.exports = {"details":"Details_details__LrasX","content":"Details_content__wwxSk","slideDown":"Details_slideDown__cqPN_","slideUp":"Details_slideUp__gLOH2","trigger":"Details_trigger__wKdpX"};